import React, { useState, useEffect, useRef, useContext } from 'react';
import { useSelector } from 'react-redux';
import { fetchWithDefaults } from '../../config/fetchDefault';
import { useDispatch } from 'react-redux';
import { setUserData} from '../../features/agentSlice';
import { setLoadingGif } from '../../features/loadingSlice';
import InputTextField from '../../utilities/helperComponents/InputTextField'
import Dropdown from '../../utilities/helperComponents/Dropdown'
import UnderlineButton from '../../utilities/helperComponents/UnderlineButton';
import Toggle from '../../utilities/helperComponents/Toggle';
import OutlineButton from '../../utilities/helperComponents/OutlineButton';
import PrimaryButton from '../../utilities/helperComponents/PrimaryButton';
import { validateEmailFormat } from '../../utilities/emailFunctions';
import { inputMask } from '../../utilities/genericUtils';
import image from '../../assets/icons/loading-loader.gif';
import AgentTags from './agentTags';
import Icon from '../../assets/icons/icon';
import '../../css/accountSettings.css';

import { setTagsToDelete, setTagsToMerge, updateDeleteTags, updateMergeTagNewName, updateMergeTags } from '../../features/tagSlice';
import BrandedButton, { brandedButtonTypes } from '../../utilities/inputComponents/BrandedButton';
import { AgentContext } from '../../context/AgentContext';
import Tooltip from '../../utilities/helperComponents/tooltip';

function AgentProfile({ fetchPage }) {
    const agentInfo = useSelector((state) => state.agent.userData);
    const loadingGif = useSelector((state) => state.loading.loading);
    const dispatch = useDispatch()
       const timezoneOptions = [
        {
            "value": "America/Puerto_Rico",
            "label": "Puerto Rico Time"
        },
        {
            "value": "America/New_York",
            "label": "Eastern Time"
        },
        {
            "value": "America/Chicago",
            "label": "Central Time"
        },
        {
            "value": "America/Denver",
            "label": "Mountain Time"
        },
        {
            "value": "America/Phoenix",
            "label": "Arizona Time"
        },
        {
            "value": "America/Los_Angeles",
            "label": "Pacific Time"
        },
        {
            "value": "America/Anchorage",
            "label": "Alaska Time"
        },
        {
            "value": "Pacific/Honolulu",
            "label": "Hawaii Time"
        }
    ]
    
    const [smartSelect, setSmartSelect] = useState(false)
    const [selectChoice, setSelectChoice] = useState(false)
    const [updateFields, setUpdateFields] = useState([])
    const [changePassword, setChangePassword] = useState(false)
    const [displayTutorial, setDisplayTutorial] = useState(agentInfo.tutorial === 1)
    const [profilePassword, setProfilePassword] = useState("")
    const [confirmedPassword, setConfirmedPassword] = useState("")
    const [usernameCheck, setUsernameCheck] = useState(false)
    const [passwordError, setPasswordError] = useState(false)
    const [confirmedPasswordError, setConfirmedPasswordError] = useState(false)
    const [loading, setLoading] = useState(false);
    const [agentFields, setAgentFields] = useState({
        UserName: agentInfo.userName,
        Email: agentInfo.email,
        FirstName: agentInfo.firstName,
        LastName: agentInfo.lastName,
        Phone: agentInfo.phone,
        TimeZone: agentInfo.timezone,
        ProfilePassword: "",
        ConfirmProfilePassword: "",
        Tutorial: agentInfo.tutorial,
        AgencyName: agentInfo.agencyName || agentInfo.organizationName,
    })

    const [errors, setErrors] = useState({
        UserName: false,
        Email: false,
        FirstName: false,
        LastName: false,
        Phone: false,
        TimeZone: false,
        ProfilePassword: false,
        ConfirmProfilePassword: false,
        AgencyName: false,
    })

    const [canSave, setCanSave] = useState(false)

    useEffect(() => {
        if (!agentInfo) return;
        setAgentFields({
            UserName: agentInfo.userName,
            Email: agentInfo.email,
            FirstName: agentInfo.firstName,
            LastName: agentInfo.lastName,
            Phone: agentInfo.phone ?? "",
            TimeZone: agentInfo.timezone,
            ProfilePassword: "",
            ConfirmProfilePassword: "",
            Tutorial: agentInfo.tutorial,
            AgencyName: agentInfo.agencyName || agentInfo.organizationName,
        });
        // Reset states on every reload
            setUpdateFields([]);
            setCanSave(false);
    }, [agentInfo]);

    const maskAndUpdatePhone = (event = null) => {
        if (event === null) {
            return
        }
        const phoneVal = inputMask(event.target.value, '(###) ###-####', '#', (r, _m, _p) => r.replace(/\D/g, ''))
        const phoneErr = phoneVal.replaceAll(/(\D)/g, '').length !== 10
        setErrors((prevErrors) => ({ ...prevErrors, ...{ Phone: phoneErr } }))
        addFieldToUpdate('Phone', phoneVal, !phoneErr && agentFields.Phone !== phoneVal)
    }
    useEffect(() => {
        setDisplayTutorial(agentInfo.tutorial === 1);
    }, [agentInfo.tutorial]);

    useEffect(() => {
        dispatch(setLoadingGif(loading))
    }, [loading])
     useEffect(() => {
        if(agentInfo.smartSelect===1){
            setSmartSelect(1)
            setSelectChoice(agentInfo.selectChoice === 1 || agentInfo.selectChoice === true)
        } else {
            setSmartSelect(false)
            setSelectChoice(false)
        }
    }, [agentInfo.smartSelect, agentInfo.selectChoice])


    useEffect(() => {
        if(agentInfo.selectChoice !== undefined && agentInfo.selectChoice !== null) {
            setSelectChoice(agentInfo.selectChoice === 1 || agentInfo.selectChoice === true)
        }
    }, [agentInfo.selectChoice])
 
    const checkUserName = async () => {
        try {
            const user = agentFields.UserName;
            setLoading(true);

            const response = await fetchWithDefaults(`/agents/agentUsernameSearch?username=${user}&agent=${agentInfo.agentId}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            setLoading(false);
            if (jsonData === false) {
                setErrors((prevErrors) => ({
                    ...prevErrors, ...{ UserName: false }
                }))
                addToUpdateFields('UserName', agentFields.UserName, true)
            }
            else {
                setErrors((prevErrors) => ({
                    ...prevErrors, ...{ UserName: true }
                }))
                addToUpdateFields('UserName', agentFields.UserName, false)
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        } finally {
            setUsernameCheck(false)
        }
    }
    useEffect(() => {
        if (usernameCheck === true) {
            checkUserName()
        }
    }, [usernameCheck])

    useEffect(() => {
        const displayVal = displayTutorial === true ? 1 : 0
        if(agentInfo.userName){
            addFieldToUpdate('Tutorial', displayVal, displayVal !== agentInfo.tutorial)
        }
    }, [displayTutorial])

    useEffect(() => {
        const displayVal = smartSelect === false ? 0 : 1
         if(agentInfo.userName){
            addFieldToUpdate('SmartSelect', displayVal, displayVal !== agentInfo.smartSelect)
         }
    }, [smartSelect])
      useEffect(() => {
        const displayVal = selectChoice === false ? 0 : 1
        if(agentInfo.userName){
            addFieldToUpdate('SelectChoice', displayVal, displayVal !== agentInfo.selectChoice)
        }
    }, [selectChoice])
    useEffect(()=>{
        if(!passwordError && !confirmedPasswordError && profilePassword.length > 0){
            addToUpdateFields('Password', profilePassword, true)
        }
        setErrors((prevErrors) => ({
            ...prevErrors,
            ...{ ProfilePassword: passwordError },
            ...{ ConfirmProfilePassword: confirmedPasswordError }
        }))
    }, [passwordError, confirmedPasswordError])

    useEffect(() => {
        setAgentFields({ ...agentFields, ...{ ProfilePassword: profilePassword } })
    }, [profilePassword])

    useEffect(() => {
        setAgentFields({ ...agentFields, ...{ ConfirmProfilePassword: confirmedPassword } })
    }, [confirmedPassword])

    useEffect(() => {
        const hasErrors = Object.values(errors).some((v) => v === true)
        const canSave = hasErrors === false && updateFields.length > 0
        setCanSave(canSave)

    }, [errors, updateFields])


    const addFieldToUpdate = (name, value, canUpdate) => {
        addToUpdateFields(name, value, canUpdate)
        setAgentFields({ ...agentFields, ...{ [name]: value } })
    }

    const addToUpdateFields = (name, value, canUpdate) => {
        if (!canUpdate) {
            removeFieldFromUpdateList(name)
            return
        }
        // const newFields = updateFields.filter((d) => Object.keys(d).some((e)=> e !== name))
        const newFields = updateFields.filter((d) => !d.hasOwnProperty(name));

        newFields.push({ [name]: value })
        setUpdateFields(newFields)
    }

    const removeFieldFromUpdateList = (field) => {
        const newFields = updateFields.filter((d) => Object.keys(d).some((e) => e !== field))
        setUpdateFields(newFields)
    }

    const onBlurHandler = (e, field, error, _prevVal) => {
        setErrors((prevErrors) => ({ ...prevErrors, ...{ [field]: error } }))
        addFieldToUpdate(field, e.target.value, !error)
    }
    const updateAgentRequest = async (endpoint, options) => {
        const response = await fetchWithDefaults(endpoint, options);
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        const jsonData = await response.json()

        return jsonData
    }

    const updateAgentFields = async () => {
        setLoading(true);
        const tablenameReduxMapping = {
            'Email': 'email',
            'TimeZone': 'timezone',
            'Tutorial': 'tutorial',
            'FirstName': 'firstName',
            'LastName': 'lastName',
            'Phone': 'phone',
            'UserName': 'userName',
            'Password': null,
            'AgencyName': 'agencyName',
            'SmartSelect': 'smartSelect',
            'SelectChoice':'selectChoice',
            'AgencyName': 'agencyName',
        }
        const backendFieldNameMapping = {
            'Email': 'email',
            'TimeZone': 'timezone',
            'Tutorial': 'tutorial',
            'FirstName': 'first_name',
            'LastName': 'last_name',
            'Phone': 'phone',
            'UserName': 'username',
            'AgencyName': 'agencyName',
            'SmartSelect':'smart_number',
            'SelectChoice':'type',
            'AgencyName': 'agencyName',
        }
        // make sure that UserName is always updated first
        // other fields depend on this field
        const sortedUpdateField = updateFields.toSorted((a, b) => {
            const aKey = Object.keys(a).pop()
            const bKey = Object.keys(b).pop()

            if (aKey === 'UserName') {
                return -1
            }

            if (bKey === 'UserName') {
                return 1
            }

            return 0
        })

        for (let index = 0;index < sortedUpdateField.length;index++) {
            const field = sortedUpdateField[index];
            const key = Object.keys(field).pop()
            const value = Object.values(field).pop()
            if ((key === 'Password')) {
                try {
                    const requestOptions = {
                        method: 'POST',
                        body: JSON.stringify({
                            username: agentFields.UserName,
                            password: value,
                            agent: agentInfo.agentId,
                        })
                    }
                    await updateAgentRequest('/loginReset/agentResetPassword', requestOptions)
                } catch (error) {
                    console.error(error)
                }
            } else {
                try {
                    const requestOptions = {
                        method: 'PATCH',
                        body: JSON.stringify({
                            column: backendFieldNameMapping[key],
                            value: value,
                            agent: agentInfo.agentId
                        })
                    }

                    const jsonData = await updateAgentRequest('/agents/update/agent', requestOptions)
                    const reduxKey = tablenameReduxMapping[key] ?? null
                    if(jsonData===true && reduxKey !== null){

                        dispatch(setUserData({[tablenameReduxMapping[key]]: value}))
                    }
                } catch (error) {
                    console.error(error)
                }
            }
        }

        setUpdateFields([])
        setLoading(false)
    }

    const resetFields = () => {
        setAgentFields({
            UserName: agentInfo.userName,
            Email: agentInfo.email,
            FirstName: agentInfo.firstName,
            LastName: agentInfo.lastName,
            Phone: agentInfo.phone ?? null,
            TimeZone: agentInfo.timezone,
            ProfilePassword: "",
            ConfirmProfilePassword: "",
            Tutorial: agentInfo.tutorial,
            AgencyName: agentInfo.agencyName || agentInfo.organizationName,
            SmartSelect: agentInfo.smartSelect,
            AgencyName: agentInfo.agencyName || agentInfo.organizationName,
        })

        setDisplayTutorial(agentInfo.tutorial === 1)
        setSmartSelect(agentInfo.smartSelect === 1)
        setSelectChoice(agentInfo.selectChoice === 1)

        setProfilePassword("")
        setConfirmedPassword("")

        const newErrors = {
            UserName: false,
            Email: !validateEmailFormat(agentInfo.email),
            FirstName: agentInfo.firstName.length === 0,
            LastName: agentInfo.lastName.length === 0,
            Phone: false,
            TimeZone: false,
            ProfilePassword: false,
            ConfirmProfilePassword: false,
            AgencyName: agentInfo.agencyName.length === 0,
        }
        setErrors(newErrors)
        setPasswordError(false)
        setConfirmedPasswordError(false)
        setUpdateFields([])
    }

    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [showExistingTagModal, setShowExistingTagModal] = useState(false)
    const [showMergeTagsModal, setShowMergeTagsModal] = useState(false)

    const tags = useSelector(state => state.tags.tags)
    const mergeTagNewName = useSelector(state => state.tags.mergeTagNewName)
    const [mergeTagNameError, setMergeTagNameError] = useState(false)

    const tagNames = tags.map((tag, _index) => {
        return tag.name
    })
    useEffect(() => {
        let tagNameError = false
        if (mergeTagNewName !== null && mergeTagNewName !== undefined && String(mergeTagNewName).trim().length > 0) {
            tagNameError = tagNames.includes(mergeTagNewName)
        }

        setMergeTagNameError(tagNameError)
    }, [mergeTagNewName])

    const scrollToDiv = (targetRef) => {
        targetRef.current.scrollIntoView({
            behavior: 'smooth', // Optional: smooth scroll effect
            block: 'start',     // Scroll to the start of the div
        });
    };

    const delModalRef = useRef()
    const existingModalRef = useRef()
    const mergeModalRef = useRef()

    useEffect(() => {
        if (showDeleteModal === true) {
            scrollToDiv(delModalRef)
        }
    }, [showDeleteModal])

    useEffect(() => {
        if (showExistingTagModal === true) {
            scrollToDiv(existingModalRef)
        }
    }, [showExistingTagModal])

    useEffect(() => {
        if (showMergeTagsModal === true) {
            scrollToDiv(mergeModalRef)
        }
    }, [showMergeTagsModal])

    const {isB2B} = useContext(AgentContext)

    return (
        <AgentContext.Provider value={{isB2B}}>
            {showDeleteModal && (
                <div ref={delModalRef} className='background-overlay'>
                    <div style={{ width: '625px', position: 'relative', background: 'white', zIndex: '2', top: '300px', left: '650px', padding: '16px 10px' }}>
                        <div style={{ width: '100%', height: '100%', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '16px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                            <div style={{ width: '100%', alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'center', gap: 16, display: 'inline-flex' }}>
                                <div style={{ color: 'black', fontSize: 26, fontFamily: 'Montserrat', fontWeight: '700', letterSpacing: 0.10, wordWrap: 'break-word' }}>Tag Deletion Confirmation</div>
                                <div onClick={() => setShowDeleteModal(false)}><Icon name={'x-close-q'} color='#707070' size={16} adjust="fontello" /></div>
                            </div>
                            <div style={{ alignSelf: 'stretch', color: '#707070', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', letterSpacing: 0.07, wordWrap: 'break-word' }}>
                                You are about to remove the tag from the selected leads. Your leads will not be affected by this change.
                            </div>
                            <div style={{ width: '100%', alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex' }}>
                                <div>
                                    <BrandedButton
                                        buttonLabel='Cancel'
                                        clickHandler={_e => { setShowDeleteModal(false); dispatch(setTagsToDelete([])) }}
                                        buttonType={brandedButtonTypes.SECONDARY}
                                    />
                                </div>
                                <div>
                                    <BrandedButton
                                        buttonLabel='Delete Tag'
                                        clickHandler={_e => dispatch(updateDeleteTags(true))}
                                        destructive={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showExistingTagModal && (
                <div ref={existingModalRef} className='background-overlay'>
                    <div id='deleteTagModal' style={{ width: '625px', position: 'relative', background: 'white', zIndex: '2', top: '300px', left: '650px', padding: '16px 10px' }}>
                        <div style={{ width: '100%', height: '100%', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '16px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                            <div style={{ width: '100%', alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'center', gap: 16, display: 'inline-flex' }}>
                                <div style={{ color: 'black', fontSize: 26, fontFamily: 'Montserrat', fontWeight: '700', letterSpacing: 0.10, wordWrap: 'break-word' }}>
                                    Tag Name Already Exist
                                </div>
                                <div onClick={() => { setShowExistingTagModal(false); dispatch(setTagsToMerge([])) }}><Icon name={'x-close-q'} color='#707070' size={16} adjust="fontello" /></div>
                            </div>
                            <div style={{ alignSelf: 'stretch', color: '#707070', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', letterSpacing: 0.07, wordWrap: 'break-word' }}>
                                A tag with this name already exists. Please enter a unique tag name or merge it with the existing tag.
                            </div>
                            <div style={{ width: '100%', alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex' }}>
                                <div>
                                    <BrandedButton
                                        buttonType={brandedButtonTypes.SECONDARY}
                                        buttonLabel='Cancel'
                                        clickHandler={_e => { setShowExistingTagModal(false); dispatch(setTagsToMerge([])); dispatch(updateMergeTags(false)); dispatch(updateMergeTagNewName(null)); }}
                                    />
                                </div>
                                <div>
                                    <BrandedButton
                                        buttonLabel='Merge Tags'
                                        clickHandler={_e => dispatch(updateMergeTags(true))}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showMergeTagsModal && (
                <div ref={mergeModalRef} className='background-overlay'>
                    <div id='mergeTagModal' style={{ width: '625px', position: 'relative', background: 'white', zIndex: '2', top: '300px', left: '650px', padding: '16px 10px' }}>
                        <div style={{ width: '100%', height: '100%', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '16px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                            <div style={{ width: '100%', alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'center', gap: 16, display: 'inline-flex', borderBottom: '2px #F1F1F1 solid' }}>
                                <div style={{ color: 'black', fontSize: 26, fontFamily: 'Montserrat', fontWeight: '700', letterSpacing: 0.10, wordWrap: 'break-word' }}>
                                    Merge Tags
                                </div>
                                <div onClick={() => { setShowMergeTagsModal(false); dispatch(setTagsToMerge([])) }}><Icon name={'x-close-q'} color='#707070' size={16} adjust="fontello" /></div>
                            </div>
                            <div style={{ alignSelf: 'stretch', color: '#707070', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', letterSpacing: 0.07, wordWrap: 'break-word' }}>
                                All merged tags will be renamed and categorized under the new tag name when you make this update.
                            </div>
                            <div style={{ alignSelf: 'stretch', background: 'white', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-end', gap: 20, display: 'inline-flex', width: '100%' }}>
                                <InputTextField
                                    inputLabel='Merged Tag Name'
                                    inputValue={mergeTagNewName}
                                    errorMsg={mergeTagNameError ? 'This tag name already exists.' : ''}
                                    changeHandler={e => dispatch(updateMergeTagNewName(e.target.value))}
                                />
                            </div>
                            <div style={{ width: '100%', alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex' }}>
                                <div>
                                    <BrandedButton
                                        buttonType={brandedButtonTypes.SECONDARY}
                                        buttonLabel='Cancel'
                                        clickHandler={_ => { setShowMergeTagsModal(false); dispatch(setTagsToMerge([])); dispatch(updateMergeTags(false)); dispatch(updateMergeTagNewName(null)); }}
                                    />
                                </div>
                                <div>
                                    <BrandedButton
                                        buttonLabel='Merge Tags'
                                        clickHandler={_ => (mergeTagNameError || mergeTagNewName.length === 0) ? null : dispatch(updateMergeTags(true))}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className='outerWrapper myAccountSectionWrapper' style={{display: 'flex', justifyContent: 'space-evenly',gap: '10px' , boxSizing:'border-box', marginLeft:'25px', flexWrap : 'wrap'}}>
                <div className = 'leftCol'style={{ width: '45%', marginTop: '20px', marginBottom: '85px', maxWidth: '763px', height : 'fit-content', paddingLeft:'7px'}}>
                    <div style={{ width: '100%', paddingLeft: 24, paddingRight: 24, paddingTop: 16, paddingBottom: 16, background: '#F1F1F1', borderBottom: '2px #F1F1F1 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 40, display: 'inline-flex', borderRadius: '5px 5px 0px 0px', }}>
                        <div style={{ flex: '1 1 0', color: '#2F2F2F', fontSize: 20, fontFamily: 'Montserrat', fontWeight: '700', wordWrap: 'break-word' }}>
                            Account Information
                        </div>
                        <div style={{ justifyContent: 'flex-start', alignItems: 'flex-start', gap: 16, display: 'flex' }} />
                    </div>
                    <div style={{ width: '100%', height: '100%', padding: 24, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex', background: 'white', borderRadius: ' 0px 0px 5px 5px', }}>
                        <div style={{ alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 40, display: 'flex' }}>
                            <div style={{ width: '100%', height: 13, color: '#2F2F2F', fontSize: 18, fontFamily: 'Montserrat', fontWeight: '700', wordWrap: 'break-word' }}>My Account</div>
                            <div style={{ alignSelf: 'stretch', height: 86, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'flex' }}>
                                <div style={{ background: 'white', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-end', gap: 20, display: 'inline-flex', flexWrap : 'wrap'}}>
                                    <InputTextField
                                        inputLabel='Username'
                                        inputValue={agentFields.UserName}
                                        errorMsg={errors.UserName ? 'The username you entered is already taken. Please choose a different one.' : ''}
                                        changeHandler={e => setAgentFields({ ...agentFields, ...{ UserName: e.target.value } })}
                                        blurHandler={e => agentInfo.userName !== e.target.value ? setUsernameCheck(true) : null}
                                        disabled={usernameCheck}
                                    />
                                </div>
                            </div>
                            <div style={{ alignSelf: 'stretch', height: 86, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'flex', marginBottom: '20px' }}>
                                <div style={{ alignSelf: 'stretch', background: 'white', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-end', gap: 20, display: 'inline-flex' }}>
                                    <InputTextField
                                        inputLabel='Email Address'
                                        inputValue={agentFields.Email}
                                        helperMsg='Your email will link to your Funnel account for alerts and notifications.'
                                        changeHandler={e => setAgentFields({ ...agentFields, ...{ Email: e.target.value } })}
                                        blurHandler={e => onBlurHandler(e, 'Email', !validateEmailFormat(e.target.value), agentFields.Email)}
                                        errorMsg={errors.Email ? 'The email you have entered does not appear to be valid.' : ''}
                                    />
                                </div>
                            </div>
                            <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', gap: 20, display: 'inline-flex' }}>
                                <div style={{ width: '100%', alignSelf: 'stretch', background: 'white', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex' }}>
                                    <InputTextField
                                        inputLabel='First Name'
                                        inputValue={agentFields.FirstName}
                                        changeHandler={e => setAgentFields({ ...agentFields, ...{ FirstName: e.target.value } })}
                                        blurHandler={e => onBlurHandler(e, 'FirstName', e.target.value.length === 0, agentFields.FirstName)}
                                        errorMsg={errors.FirstName ? 'Enter your first name.' : ''}
                                    />
                                </div>
                                <div style={{ width: '100%', alignSelf: 'stretch', background: 'white', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex' }}>
                                    <InputTextField
                                        inputLabel='Last Name'
                                        inputValue={agentFields.LastName}
                                        changeHandler={e => setAgentFields({ ...agentFields, ...{ LastName: e.target.value } })}
                                        blurHandler={e => onBlurHandler(e, 'LastName', e.target.value.length === 0, agentFields.LastName)}
                                        errorMsg={errors.LastName ? 'Enter your last name.' : ''}
                                    />
                                </div>
                            </div>
                            <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', gap: 20, display: 'inline-flex' }}>
                                <div style={{ width: '100%', alignSelf: 'stretch', background: 'white', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex' }}>
                                    <InputTextField
                                        inputLabel='Phone Number'
                                        inputValue={agentFields.Phone}
                                        changeHandler={e => maskAndUpdatePhone(e)}
                                        errorMsg={errors.Phone ? 'The phone number must be 10 digits.' : ''}
                                        maxLength={14}
                                    />
                                </div>
                                <div style={{ width: '100%', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex' }}>
                                    <Dropdown
                                        inputLabel='Time Zone'
                                        inputValue={agentFields.TimeZone}
                                        options={timezoneOptions}
                                        changeHandler={e => addFieldToUpdate('TimeZone', e.target.value, agentFields.timezone !== e.target.value)}
                                    />
                                </div>
                            </div>
                            <div style={{ alignSelf: 'stretch', height: 86, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'flex', marginBottom: '20px' }}>
                                <div style={{ alignSelf: 'stretch', background: 'white', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-end', gap: 20, display: 'inline-flex' }}>
                                    <InputTextField
                                        inputLabel='Agency Name'
                                        inputValue={agentFields.AgencyName}
                                        changeHandler={e => setAgentFields({ ...agentFields, ...{ AgencyName: e.target.value } })}
                                        blurHandler={e => onBlurHandler(e, 'AgencyName', e.target.value.trim().length === 0, agentFields.AgencyName)}
                                        errorMsg={errors.AgencyName ? 'Enter your agency name.' : ''}
                                    />
                                </div>
                            </div>
                            <div style={{ alignSelf: 'stretch', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex', flexDirection: 'column' }}>
                                <div style={{ width: '100%', height: '100%', color: '#2F2F2F', fontSize: 18, fontFamily: 'Montserrat', fontWeight: '700', wordWrap: 'break-word' }}>Preferences</div>
                                <div style={{ width: '100%', height: '100%', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'inline-flex' }}>
                                    <div style={{ justifyContent: 'flex-start', alignItems: 'flex-end', gap: 32, display: 'inline-flex', width: '100%' }}>
                                        <Toggle
                                            toggleHandler={_e => setDisplayTutorial(prev => !prev)}
                                            toggleOn={displayTutorial}
                                            toggleText='Display Account Setup Tutorial'
                                        />
                                    </div>
                                </div>
                                <div style={{ width: '100%', height: '100%', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'inline-flex' }}>
                                    <div style={{ justifyContent: 'flex-start', alignItems: 'flex-end', gap: 32, display: 'inline-flex', width: '100%' }}>
                                        
                                        <Toggle
                                            toggleHandler={e => setSmartSelect(!smartSelect)}
                                            toggleOn={smartSelect}
                                            toggleText='Smart Number Select'
                                        />
                                        

                                        <span className="toolTipAccountWrapper">
                                            <div className="toolTipAccount">i</div>
                                            <div className="toolTipAccountTip">
                                                <Tooltip 
                                                    customTipClass={'customTipClass'}
                                                    title='What is Smart Number Select?'
                                                    body={`Smart Number Select automatically chooses the most geographically appropriate phone number for outbound calls. You can customize it to select from either all available numbers or only those that support text messaging.`} 
                                                />
                                            </div>
                                        </span>
                                    </div>
                                    {smartSelect==1 && (
                                        <div className="subOptions">
                                            <div className="subOption">
                                                <input type="radio" name="smartSelectRadio" onChange={e => setSelectChoice(false)} checked={!selectChoice}/>  <span className="radioText">Smart Select From Text Capable Numbers</span>
                                            </div>
                                            <div className="subOption">
                                                <input type="radio" name="smartSelectRadio" onChange={e => setSelectChoice(true)} checked={selectChoice}/> <span className="radioText">Smart Select From All Numbers</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex' }}>
                                <div>
                                    <BrandedButton
                                        buttonLabel='Cancel'
                                        buttonType={brandedButtonTypes.SECONDARY}
                                        clickHandler={_e => resetFields()}
                                    />
                                </div>
                                <div>
                                    <BrandedButton
                                        buttonLabel='Save Changes'
                                        disabled={!canSave}
                                        clickHandler={_e => canSave ? updateAgentFields() : null}
                                    />
                                </div>
                            </div>
                            <div style={{ width: '100%', height: '100%', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'inline-flex' }}>
                                <div style={{ justifyContent: 'flex-start', alignItems: 'flex-end', gap: 4, display: 'inline-flex' }}>
                                    <div style={{ color: '#707070', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word' }}>Looking for billing? </div>
                                </div>
                                <div style={{ flex: '1 1 0', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex' }}>
                                    <BrandedButton
                                        buttonLabel='Click here to go to Subscription'
                                        buttonType={brandedButtonTypes.TERTIARY}
                                        clickHandler={_e => fetchPage('Subscription')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='rightCol' style={{width : '46%' , marginLeft: '26px'}}>
                    <AgentTags setShowDeleteModal={setShowDeleteModal} setShowExistingTagModal={setShowExistingTagModal} setShowMergeTagsModal={setShowMergeTagsModal} />
                </div>
            </div>


            {loadingGif && (
                <div className="loadingScreen">
                    <div className="loaderWrapper">
                        <img src={image} alt="Loading Gif" style={{ width: '100%' }} />
                    </div>
                </div>
            )}
        </AgentContext.Provider>
    );
}
export default AgentProfile;
